import React from 'react';
import PropTypes from 'prop-types';

import Badge from 'react-bootstrap/Badge';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const StatusBadges = ({ status }) => {
  switch (status) {
    case 'Active':
    case 'A':
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-active-badge" style={{ margin: 0 }}>Active</Tooltip>}
        >
          <Badge pill className="width-2 badge-active" aria-label="Active" role="img">
            A
          </Badge>
        </OverlayTrigger>
      );
    case 'Expired':
    case 'E':
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-expired-badge" style={{ margin: 0 }}>Expired</Tooltip>}
        >
          <Badge pill className="width-2 badge-expired" aria-label="Expired" role="img">
            X
          </Badge>
        </OverlayTrigger>
      );
    case 'Incomplete':
    case 'I':
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-incomplete-badge" style={{ margin: 0 }}>Incomplete</Tooltip>}
        >
          <Badge pill className="width-2 badge-incomplete" aria-label="Incomplete" role="img">
            I
          </Badge>
        </OverlayTrigger>
      );
    case 'Pending':
    case 'P':
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-pending-badge" style={{ margin: 0 }}>Pending</Tooltip>}
        >
          <Badge pill className="width-2 badge-pending" aria-label="Pending" role="img">
            P
          </Badge>
        </OverlayTrigger>
      );
    case 'Sold':
    case 'S':
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-sold-badge" style={{ margin: 0 }}>Sold</Tooltip>}
        >
          <Badge pill className="width-2 badge-sold" aria-label="Sold" role="img">
            S
          </Badge>
        </OverlayTrigger>
      );
    case 'Terminated':
    case 'T':
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-terminated-badge" style={{ margin: 0 }}>Terminated</Tooltip>}
        >
          <Badge pill className="width-2 badge-terminated" aria-label="Terminated" role="img">
            T
          </Badge>
        </OverlayTrigger>
      );
    case 'Withdrawn':
    case 'W':
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-withdrawn-badge" style={{ margin: 0 }}>Withdrawn</Tooltip>}
        >
          <Badge pill className="width-2 badge-withdrawn" aria-label="Withdrawn" role="img">
            W
          </Badge>
        </OverlayTrigger>
      );
    default:
      return '';
  }
};

StatusBadges.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusBadges;
